<template>
  <div class="embedly-placeholder" @click="$emit('click')">
    <img v-if="placeholderImageUrl" :src="placeholderImageUrl" class="img-fluid" @click="$emit('click')">

    <div v-else class="p-3 bg-primary-dark text-on-primary-dark">
      {{ i18n.t('public.embedly.click_to_show') }}
    </div>
  </div>
</template>

<script>
export default {
  emits: ['click'],

  computed: {
    placeholderImageUrl() {
      return this.agraConfiguration.embedly.placeholderImageUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.embedly-placeholder {
  cursor: pointer;
}
</style>
